/** Cookie key for the access token */
export const TOKEN_COOKIE = "p-ai-accessToken";

/** Query parameter name used to pass the token back via redirect URL */
export const TOKEN_QUERY_PARAM = "accessToken";
